import { ColumnHelpers } from '@westernmilling/eu_react_shared';

const Columns = (context) => [
  {
    Header: 'System',
    accessor: 'system_name',
    className: 'text-left',
  },
  {
    Header: 'System Reference',
    accessor: 'system_reference',
    className: 'text-left',
  },
  ColumnHelpers.activeInactiveColumn(),
  ColumnHelpers.auditLogLink(context),
  ColumnHelpers.columnEditButton(context),
];

export default Columns;
